import { RegisterationSteps } from './auth-enums';

/**
 * Three-bar progress for the phone-first registration flow.
 * `phoneOtpRequired` comes from request-phone-otp. A null flag is the
 * phone entry screen, before that response exists.
 */
export function registrationProgress(
  step: RegisterationSteps,
  phoneOtpRequired: boolean | null
): number[] {
  if (phoneOtpRequired === false) {
    switch (step) {
      case RegisterationSteps.PHONE:
        return [33.33, 0, 0];
      case RegisterationSteps.PASSWORD:
        return [66, 0, 0];
      case RegisterationSteps.EMAIL:
        return [100, 33.33, 0];
      case RegisterationSteps.VERIFY_EMAIL_OTP:
        return [100, 66, 0];
      case RegisterationSteps.ABOUT:
        return [100, 100, 33.33];
      case RegisterationSteps.PROFESSION:
        return [100, 100, 66];
      default:
        return [33.33, 0, 0];
    }
  }

  switch (step) {
    case RegisterationSteps.PHONE:
      return [33.33, 0, 0];
    case RegisterationSteps.VERIFY_PHONE_OTP:
      return [66, 0, 0];
    case RegisterationSteps.PASSWORD:
      return [100, 33.33, 0];
    case RegisterationSteps.ABOUT:
      return [100, 100, 33.33];
    case RegisterationSteps.PROFESSION:
      return [100, 100, 66];
    default:
      return [33.33, 0, 0];
  }
}
